import { useInView } from "react-intersection-observer";
import { useAnimationControls } from "framer-motion";

export const useScroll = () =>{
    const controls = useAnimationControls();
    const [element, view] = useInView({ 
        threshold: .6,
    });
    if(view){
        controls.start("animate");
    }else{
        controls.start("exit");
    }
    return [element, controls];
}